import styled, { css } from 'styled-components';
import { GEL_GROUP_3_SCREEN_WIDTH_MIN, GEL_GROUP_3_SCREEN_WIDTH_MAX } from '@bbc/gel-foundations/breakpoints';
import { GEL_SPACING_DBL } from '@bbc/gel-foundations/spacings';
import { grid } from '@bbc/psammead-styles/detection';
var fourOfSixColumnsMaxWidthScaleable = "66.67%"; // (4 / 6) * 100 = 66.6666666667 = 66.67%

var fullWidthColumnsMaxScaleable = "100%"; // (12 / 12) * 100 = 100 = 100%

var halfWidthColumnsMaxScaleable = "50%";
var paddingStyles = /*#__PURE__*/css(["", ""], function (_ref) {
  var dir = _ref.dir;
  return dir === 'ltr' ? "padding-left: ".concat(GEL_SPACING_DBL, ";") : "padding-right: ".concat(GEL_SPACING_DBL, ";");
});
var textGridFallbackRadio = /*#__PURE__*/css(["@media (min-width:", ") and (max-width:", "){", " ", "}"], GEL_GROUP_3_SCREEN_WIDTH_MIN, GEL_GROUP_3_SCREEN_WIDTH_MAX, function (_ref2) {
  var fullWidth = _ref2.fullWidth;
  return !fullWidth && "width: ".concat(fourOfSixColumnsMaxWidthScaleable, ";");
}, paddingStyles);
var textGridFallbackTv = /*#__PURE__*/css(["@media (min-width:", "){", " ", "}"], GEL_GROUP_3_SCREEN_WIDTH_MIN, function (_ref3) {
  var fullWidth = _ref3.fullWidth;
  return !fullWidth && "width: ".concat(halfWidthColumnsMaxScaleable, ";");
}, paddingStyles);
var textGridRadio = /*#__PURE__*/css(["@media (min-width:", ") and (max-width:", "){grid-column:3 / span 4;padding:0;}"], GEL_GROUP_3_SCREEN_WIDTH_MIN, GEL_GROUP_3_SCREEN_WIDTH_MAX);
var textGridTv = /*#__PURE__*/css(["@media (min-width:", "){grid-column:4 / span 3;padding:0;}"], GEL_GROUP_3_SCREEN_WIDTH_MIN);
var textGridFallbackStyles = {
  radio: textGridFallbackRadio,
  tv: textGridFallbackTv
};
var textGridStyles = {
  radio: textGridRadio,
  tv: textGridTv
};
var TextGridItem = /*#__PURE__*/styled.div.withConfig({
  displayName: "TextGridItem",
  componentId: "sc-1uyu5iz-0"
})(["display:inline-block;width:", ";", " @supports (", "){width:initial;grid-column:1 / span 6;", "}"], fullWidthColumnsMaxScaleable, function (_ref4) {
  var bulletinType = _ref4.bulletinType;
  return textGridFallbackStyles[bulletinType];
}, grid, function (_ref5) {
  var bulletinType = _ref5.bulletinType,
      fullWidth = _ref5.fullWidth;
  return !fullWidth && textGridStyles[bulletinType];
});
export default TextGridItem;